import { useState } from 'react';

import { AppIcons, AppIcon } from '@backrs_ui/common-ui';

import { Box, Typography, SxProps, Theme, Tooltip, ClickAwayListener } from '@mui/material';

type LineIconItemProps = Readonly<{
  title: string;
  iconName?: AppIcons;
  text?: string;
  infoTooltip?: string;
}>;

export const LineIconItem = ({ title, iconName, text, infoTooltip }: LineIconItemProps) => {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  return (
    <Box sx={enrollmentContainerSx}>
      <Box sx={titleContainerSx}>
        <Typography
          variant="text-md-semibold"
          color={({ backrs }) => backrs.colors['Brand/500']}
          sx={titleSx}
        >
          {title}
        </Typography>

        {infoTooltip && (
          <ClickAwayListener onClickAway={() => setIsTooltipOpen(false)}>
            <Tooltip
              open={isTooltipOpen}
              onClose={() => setIsTooltipOpen(false)}
              title={infoTooltip}
              placement="top"
              arrow
              disableFocusListener
              disableHoverListener
              disableTouchListener
            >
              <Box sx={infoTooltipIconSx} onClick={() => setIsTooltipOpen((prev) => !prev)}>
                <AppIcon iconName="InfoCircle" diameter="16px" color="Brand/500" />
              </Box>
            </Tooltip>
          </ClickAwayListener>
        )}
      </Box>

      {text && (
        <Box sx={enrollmentContentContainerSx}>
          {iconName && <AppIcon iconName={iconName} diameter="20px" color="Colors/Base/Black" />}

          <Typography variant="text-md-medium">{text}</Typography>
        </Box>
      )}
    </Box>
  );
};

const enrollmentContainerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-md'],
});

const enrollmentContentContainerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: backrs.spacing['spacing-md'],
  alignItems: 'center',
});

const infoTooltipIconSx: SxProps<Theme> = ({ backrs }) => ({
  marginLeft: backrs.spacing['spacing-sm'],
  cursor: 'pointer',
});

const titleContainerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: backrs.spacing['spacing-none'],
});

const titleSx: SxProps<Theme> = {
  width: 'max-content',
};
